import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Customers from "./index";

export default function ActivityPageRoutes(props) {
  const { match } = props;
  return (
    <>
      <Switch>
        <Route exact path={`${match.url}`} component={Customers} />
        <Route exact path={`${match.url}/:peopleId`} component={Customers} />
        <Route exact path={`${match.url}/:moduleName/:linkedId`} component={Customers} />
        <Redirect to={`${match.url}`} />
      </Switch>
    </>
  );
}
